import { BaseApiClient } from '../base-api-client';
export class ReferralClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/referrals`,
        };
        super(fullConfig, 'ReferralClient');
    }
    async isUserReferred(telegramId) {
        try {
            const response = await this.get(`/is-referred/${telegramId}`);
            return response.success && !!response.data;
        }
        catch (error) {
            console.error('[ReferralClient] Error checking if user is referred:', this.truncateError(error));
            return false;
        }
    }
    async joinWithReferral(telegramId, referralCode) {
        try {
            const response = await this.post('/user-join', {
                telegramId,
                referralCode,
            });
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to join with referral');
            }
            const data = response.data;
            if (data.message && !data.isNewReferral) {
                throw new Error(data.message);
            }
            return data;
        }
        catch (error) {
            console.error('[ReferralClient] Error joining with referral:', this.truncateError(error));
            throw error;
        }
    }
    async processNewUserWithReferral(telegramId, referrerTelegramId, _username, _firstName, _lastName) {
        await this.joinWithReferral(telegramId, referrerTelegramId);
    }
    async createUserWithoutReferral(telegramId, _username, _firstName, _lastName) {
        await this.joinWithReferral(telegramId);
    }
    async getReferralStats(telegramId) {
        try {
            const response = await this.get(`/stats/${telegramId}`);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to get referral stats');
            }
            return response.data;
        }
        catch (error) {
            console.error('[ReferralClient] Error getting referral stats:', this.truncateError(error));
            throw error;
        }
    }
    async getLeaderboard(limit = 10) {
        try {
            const response = await this.get(`/leaderboard?limit=${limit}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to get leaderboard');
            }
            return response.data || [];
        }
        catch (error) {
            console.error('[ReferralClient] Error getting leaderboard:', this.truncateError(error));
            throw error;
        }
    }
    async getUserRank(telegramId) {
        try {
            const response = await this.get(`/rank/${telegramId}`);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to get user rank');
            }
            return response.data.rank;
        }
        catch (error) {
            console.error('[ReferralClient] Error getting user rank:', this.truncateError(error));
            throw error;
        }
    }
    async getWhitelistStatus(telegramId) {
        try {
            const response = await this.get(`/whitelist-status/${telegramId}`);
            if (!response.success || !response.data) {
                throw new Error(response.error || 'Failed to get whitelist status');
            }
            return response.data;
        }
        catch (error) {
            console.error('[ReferralClient] Error getting whitelist status:', this.truncateError(error));
            throw error;
        }
    }
}
//# sourceMappingURL=referral-client.js.map